<template>
    <cube-scroll ref="scroll" class="ratings" :options="scrollOptions">
        <div class="ratings-content">
            <div class="overview">
                <div v-if="store.store_credit.store_desccredit.credit != 0" class="overview-left">
                    <h1 class="score">{{store.store_credit.store_desccredit.credit}}</h1>
                    <span class="common-score-wrapper star"><i class="iconfont front" :style="{width:store.store_credit.store_desccredit.credit/5*100+'%'}"></i></span>
                    <!-- <div class="title">{{ $t('store.evaluate_count', [ratings.length]) }}</div> -->
                </div>
                <div v-else class="overview-left-empty">
                  <img src="@/assets/image/member/star.png" style="width: 15px; padding-right: 6px; padding-bottom: 4px;">{{ $t('store.no_credit') }}
                </div>
                <div class="overview-right" v-if="store.store_credit">
                    <ul :class="{ active : flag }">
                        <li v-for="(item, index) in profile" :key="index">
                            <span v-html="item.text"></span>
                        </li>
                     </ul>
                     <p v-if ="profile.length>2" @click = "showTag">
                        <span :class="{ 'rotate': flag }" style="color: #FF0404; font-size: 30px;">
                            <i class="cubeic-select"></i>
                        </span>
                    </p>
                    <!-- <div class="score-wrapper">
                        <span class="title">配送速度</span>
                        <span class="common-score-wrapper"><i class="iconfont front" :style="{width:store.store_credit.store_deliverycredit.credit/5*100+'%'}"></i></span>
                        <span class="score">{{store.store_credit.store_deliverycredit.credit}}</span>
                    </div>
                    <div class="score-wrapper">
                        <span class="title">商品评分</span>
                        <span class="common-score-wrapper"><i class="iconfont front" :style="{width:store.store_credit.store_desccredit.credit/5*100+'%'}"></i><i class="iconfont back"></i></span>
                        <span class="score">{{store.store_credit.store_desccredit.credit}}</span>
                    </div>
                    <div class="score-wrapper">
                        <span class="title">服务态度</span>
                        <span class="common-score-wrapper"><i class="iconfont front" :style="{width:store.store_credit.store_servicecredit.credit/5*100+'%'}"></i><i class="iconfont back"></i></span>
                        <span class="score">{{store.store_credit.store_servicecredit.credit}}</span>
                    </div> -->
                </div>
            </div>
            <split></split>
            <!-- <rating-select
                    @select="onSelect"
                    @toggle="onToggle"
                    :selectType="selectType"
                    :onlyContent="onlyContent"
                    :ratings="ratings"
            >
            </rating-select>
            <div class="rating-wrapper">
                <ul style="height: auto">
                    <li
                        v-for="(rating,index) in computedRatings"
                        :key="index"
                        class="rating-item border-bottom-1px"
                    >
                        <div class="avatar">
                            <img width="28" height="28" :src="rating.geval_goodsimage_url">
                        </div>
                        <div class="content">
                            <div style="display: flex;">
                                <h1 class="name">{{rating.geval_goodsname}}</h1>
                                <div class="time">
                                    {{format(rating.geval_addtime)}}
                                </div>
                            </div>
                            <div class="star-wrapper">
                                <span class="common-score-wrapper"><i class="iconfont front" :style="{width:rating.geval_scores/5*100+'%'}"></i><i class="iconfont back"></i></span>

                            </div>
                            <p class="text">{{rating.geval_content}}</p>

                        </div>
                    </li>
                </ul>
            </div> -->
        </div>
    </cube-scroll>
</template>

<script>
import { getStoreRatings } from '../../../api/homestoredetail'
import RatingSelect from './common/rating-select'
import Split from './common/split'
import ratingMixin from './common/mixins/rating'
import moment from 'moment'

export default {
  name: 'StoredetailTabRatings',
  mixins: [ratingMixin],
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      ratings: [],
      flag: false,
      scrollOptions: {
        click: false,
        directionLockThreshold: 0
      }
    }
  },
  computed: {
    store () {
      return this.data.store || {}
    },
    profile () {
      let dayOfWeek = []
      let result = []
      this.store.store_o2o_business_hours.forEach((item) => {
        item.weeks.forEach((dow) => {
          dayOfWeek.push({dow: dow, openAt: item.period.open_at, closeAt: item.period.close_at})
        })
      })
      dayOfWeek.sort((a, b) => {
        let today = moment().weekday()
        a.dow = (a.dow < today)? a.dow + 7 : a.dow
        b.dow = (b.dow < today)? b.dow + 7 : b.dow
        return moment().weekday(a.dow).valueOf() - moment().weekday(b.dow).valueOf()
      })

      result.push({
        text: this.$t('store.address', [this.store.store_address])
      })
      result.push({
        text: this.$t('store.business_hours') + ': '
      })
      dayOfWeek.forEach((dow) => {
        result.push({
          text: moment().weekday(dow.dow).format('dddd') + ': ' + moment().set({hour: 0, minute: dow.openAt, second: 0}).format('Ahh:mm') + ' ~ ' + moment().set({hour: 0, minute: dow.closeAt, second: 0}).format('Ahh:mm')
        })
      })
      return result
    }
  },
  methods: {
    fetch () {
      if (!this.fetched) {
        this.fetched = true
        getStoreRatings(
          this.store.store_id
        ).then((res) => {
          this.ratings = res.result
        })
      }
    },
    format (time) {
      return moment(time * 1000).format('YYYY-MM-DD hh:mm')
    },
    showTag () {
      this.flag = !this.flag
    }
  },
  components: {
    Split,
    RatingSelect
  },
  watch: {
    selectType () {
      this.$nextTick(() => {
        this.$refs.scroll.refresh()
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
    .common-score-wrapper .back{display:block}
    .ratings
        position: relative
        text-align: left
        white-space: normal
        height: 100%
        .overview
            display: flex
            padding: 0.9rem 0 0
            .overview-left
                flex: 0 0 6.85rem
                display: flex
                flex-direction: column
                align-items: center
                padding: 0.3rem 0
                width: 6.85rem
                border-right: 1px solid $color-col-line
                text-align: center
                @media only screen and (max-width: 320px)
                    flex: 0 0 6rem
                    width: 6rem
                .score
                    line-height: 1.4rem
                    font-size:1.2rem
                    color: #fc9153
                .title
                    margin-bottom: 0.4rem
                    line-height: 0.6rem
                    font-size: 0.8rem
                    color:#333
                .rank
                    font-size: 1.2rem
                    color: #f01414
                .star
                    overflow: hidden
                    height: 1.6rem
                    text-align: left
                    display: flex
                    justify-content: center
                    align-items: center
                    margin-left: 0px
                    margin-bottom: 8px
            .overview-left-empty
                align-items: center
                margin: auto
                width: 6.85rem
                border-right: 1px solid $color-col-line
                text-align: center
                @media only screen and (max-width: 320px)
                    width: 6rem
            .overview-right
                flex: 1
                padding: 0.3rem
                @media only screen and (max-width: 320px)
                    padding-left: 0.3rem
                .score-wrapper
                    display: flex
                    align-items: center
                    margin-bottom: 0.4rem
                .title
                    line-height: 0.9rem
                    font-size: 0.6rem
                    color:#333
                .star
                    margin: 0 0.6rem
                .score
                    line-height: 0.9rem
                    font-size: 0.6rem
                    color: #fc9153
                li
                    width: 100%
        .rating-wrapper
            padding: 0 0.9rem
            .rating-item
                display: flex
                padding: 0.9rem 0
                &:last-child
                    border-none()
                .avatar
                    flex: 0 0 1.4rem
                    width: 1.4rem
                    margin-right: 0.6rem
                    img
                        height: auto
                        border-radius: 50%
                .content
                    position: relative
                    flex: 1
                    .name
                        margin-bottom: 0.2rem
                        line-height: 0.6rem
                        font-size: 0.5rem
                        color: #333
                        max-width:10rem
                    .star-wrapper
                        margin-bottom: 0.3rem
                        display: flex
                        align-items: center
                        .star
                            margin-right: 0.3rem
                        .delivery
                            font-size: 0.5rem
                            color: #999
                    .text
                        margin-bottom: 0.4rem
                        line-height: 0.9rem
                        color: #333
                        font-size: 0.6rem
                    .recommend
                        display: flex
                        align-items: center
                        flex-wrap: wrap
                        line-height: 0.8rem
                        .icon-thumb_up, .item
                            margin: 0 0.4rem 0.2rem 0
                            font-size:0.5rem
                        .icon-thumb_up
                            color: #00a0dc
                        .item
                            padding: 0 0.3rem
                            border: 1px solid $color-row-line
                            border-radius: 1px
                            color: #999
                            background: #fff
                    .time
                        position: absolute
                        top: 0
                        right: 0
                        line-height: 0.6rem
                        font-size:0.6rem
                        color:#999
</style>
<style scoped>
ul {
    width: 100%;
    height: 90px;
    line-height: 50px;
    overflow: hidden;
}
.active {
    overflow: visible;
    height: auto;
}
li {
    width: 80vw;
    word-break: break-all;
    font-size: 14px;
    line-height: 30px;
}
span{
    display: inline-block;
    margin-left: 10px;
    font-size: 14px;
    color: black;
    line-height: 30px;
}
.rotate {
    transform: rotate(180deg);
}
</style>
